import React, { useState, useEffect } from 'react';
import GetRequest from '../../../service/GetRequest';
import { Button } from 'primereact/button';
import { useNavigate } from "react-router-dom";
import ImagePicker from "../../LoginFormComponents/ImagePicker";
import CookieHandler from '../../../pages/LandingPage/Authentication/CookieHandler'
import axios from 'axios';
import FormSeperator from '../../LoginFormComponents/FormSeperator';
import InputFieldText from '../Inputs/InputFieldText';
import InputFeildTextArea from '../Inputs/InputFeildTextArea';
import InputSelectionDropdown from '../Inputs/InputSelectionDropdown';
import InputPriceField from '../Inputs/InputPriceField';
import { AutoComplete } from "primereact/autocomplete";


const AddProductForm = ({branchId,onSubmit,onCancel}) => {

    const token = CookieHandler.getCookie('token');

    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [filteredCategories, setFilteredCategories] = useState([]);


    const [selectedCategoryName, setSelectedCategoryName] = useState();
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [image, setImage] = useState(null);
    const [size, setSize] = useState("Small");
    const [color, setColor] = useState("Black");
    const [material, setMaterial] = useState("");
    const [quantity, setQuantity] = useState(0);
    const [sellingPrice, setSellingPrice] = useState(0);
    const [purchasePrice, setPurchasePrice] = useState(0);
    const [currency, setCurrency] = useState("GBP");
    const [isTaxable, setIsTaxable] = useState(null);
    const [taxRate, setTaxRate] = useState(0);
    const [sellerDescription, setSellerDescription] = useState("");
    const [warrantyDetails, setWarrantyDetails] = useState("");

    const sizeOptions = [
        { value: 'Small', label: 'Small' },
        { value: 'Medium', label: 'Medium' },
        { value: 'Large', label: 'Large' },
    ];

    const currencyOptions = [
        { value: 'GBP', label: 'British Pound (GBP)' },
        { value: 'INR', label: 'Indian Rupee (INR)' },
        { value: 'USD', label: 'US Dollar (USD)' },
        { value: 'EUR', label: 'Euro (EUR)' },
        { value: 'JPY', label: 'Japanese Yen (JPY)' },
        { value: 'CAD', label: 'Canadian Dollar (CAD)' },
        { value: 'AUD', label: 'Australian Dollar (AUD)' },
        { value: 'CNY', label: 'Chinese Yuan (CNY)' },
        { value: 'CHF', label: 'Swiss Franc (CHF)' },
        { value: 'BRL', label: 'Brazilian Real (BRL)' },
    ];

    useEffect(() => {
        GetRequest(`v1/inventory-service/view/branches/${branchId}/categories`,true)
            .then(response => {
                if (response) {
                    setCategories(response);
                    setSelectedCategoryName(response[0].name)
                } else {
                    console.log("No categories found for this branch");
                }
            })
            .catch(error => {
                console.error("Error fetching categories:", error);
            });
    }, [branchId]);

    const handleNameChange = (e) => setName(e.target.value);

    const search = (event) => {
        setTimeout(() => {
            let _filteredCategories;

            if (!event.query.trim().length) {
                _filteredCategories = [...categories];
            } else {
                _filteredCategories = categories.filter((category) => {
                    return category.name.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredCategories(_filteredCategories);
        }, 250);
    }



    const handleCategoryChange = (e) => {
        const inputCategory = e.value;
        const existingCategory = categories.find(category => category.name.toLowerCase() === inputCategory.toLowerCase());
    
        if (existingCategory) {
            setSelectedCategory(existingCategory);
            setSelectedCategoryName(existingCategory.name);
        } else {
            // Create a new category object
            const newCategory = {
                value: categories.length + 1, // You can generate a unique ID as needed
                name: inputCategory
            };
            setCategories([...categories, newCategory]);
            setSelectedCategory(newCategory);
            setSelectedCategoryName(newCategory.name);
        }
    };


    const handleDescriptionChange = (e) => setDescription(e.target.value);
    const handleImageChange = (file) => setImage(file);
    const handleSizeChange = (e) => setSize(e.target.value);
    const handleCurrencyChange = (e) => setCurrency(e.target.value);
    const handleColorChange = (e) => setColor(e.target.value);
    const handleMaterialChange = (e) => setMaterial(e.target.value);
    const handleQuantityChange = (e) => setQuantity(Number(e.target.value));
    const handleSellingPriceChange = (e) => setSellingPrice(Number(e.target.value));
    const handlePurchasePriceChange = (e) => setPurchasePrice(Number(e.target.value));
    const handleIsTaxableChange = (e) => setIsTaxable(e.target.value === "true");
    const handleTaxRateChange = (e) => setTaxRate(Number(e.target.value));
    const handleSellerDescriptionChange = (e) => setSellerDescription(e.target.value);
    const handleWarrantyDetailsChange = (e) => setWarrantyDetails(e.target.value);

    const addProduct = async () => {
        const data = {
            name,
            description,
            size,
            color,
            material,
            quantity,
            sellingPrice,
            purchasePrice,
            currency,
            isTaxable,
            taxRate,
            sellerDescription,
            warrantyDetails,
        };
    
        try {
            const formData = new FormData();
            formData.append('data', new Blob([JSON.stringify(data)], { type: 'application/json' }));
            formData.append('file', image);
    
            const apiUrl = process.env.REACT_APP_API_URL;
            console.log('API URL:', apiUrl);
    
            const response = await axios.post(`${apiUrl}/api/v1/inventory-service/branch/${branchId}/add/product`, formData, {
                params: { category: selectedCategoryName }, // Ensure this matches what the API expects
                headers: { 
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`
                }
            });
    
            if (!response) {
                console.log("Product addition failed");
            } else {
                console.log("Product added successfully");
                onSubmit();
            }
    
            console.log('Item saved successfully:', response.data);
        } catch (error) {
            console.error('Error saving item:', error);
        }
    };


  return (
    <div>

            <div className="flex gap-5 justify-between self-start mt-5 font-medium">

                            <div style={{ minWidth: '100px', minHeight: '100px' }} className="card text-neutral-600">
                               <ImagePicker image={image} handleInputChange={handleImageChange} />

                            </div>
                                    <div className="flex flex-col my-auto">
                                        <div className="text-base">Product image</div>
                                        <div className="mt-1.5 text-xs text-sky-500">
                                            {image ? `(${image.name}) selected` : "(No file selected)"}
                                        </div>
                                    </div>
                                </div>

            <FormSeperator content="Basic Details" />

            <div className="g">
            
            
            
            <div className="card flex flex-wrap gap-3 p-fluid">
                    <div className="flex-auto">
                        <label htmlFor="calendar-12h" className="font-bold block mb-2">
                            Enter Product name                                
                        </label>
                        <InputFieldText value={name} onChange={handleNameChange} label="Enter Product name"/>
                    </div>
                    <div className="flex-auto">
                        <label htmlFor="calendar-12h" className="font-bold block mb-2">
                                Enter Category name                               
                        </label>
                        <AutoComplete field="name" value={selectedCategory} suggestions={filteredCategories} completeMethod={search} onChange={handleCategoryChange} placeholder="Enter category name"/>

                    
                    </div></div>
                
                    <div className="flex-auto">
                            <InputFeildTextArea value={description} onChange={handleDescriptionChange} label="Enter Description"/>
                    </div>
                 
                
                <FormSeperator content="Other Details" />

                <div className="card flex flex-wrap gap-3 p-fluid">
                    <div className="flex-auto">
                        <label htmlFor="calendar-12h" className="font-bold block mb-2">
                            Material                        
                        </label>
                        <InputFieldText value={material} onChange={handleMaterialChange} label="Enter Material"/>
                    </div>
                    <div className="flex-auto">
                        <label htmlFor="calendar-12h" className="font-bold block mb-2">
                            Color                        
                        </label>
                        <InputFieldText value={color} onChange={handleColorChange} label="Enter Color"/>
                    </div>
                    <div className="flex-auto">
                        <label htmlFor="calendar-12h" className="font-bold block mb-2">
                                Choose the Size                        
                            </label>
                        <InputSelectionDropdown 
                                    value={size}
                                    onChange={handleSizeChange}
                                    options={sizeOptions}
                                    optionLabel="label" 
                                    placeholder="Size" 
                            />
                       </div>
                </div>

                <FormSeperator content="Quantity & Pricing Details" />
                    <div className="card flex flex-wrap gap-3 p-fluid">
                        <div className="flex-auto">
                            <label htmlFor="calendar-12h" className="font-bold block mb-2">
                                    Quantity                        
                                </label>
                                <InputFieldText value={quantity} onChange={handleQuantityChange} label="Enter Quantity"/>
                        </div>
                        <div className="flex-auto">
                                <InputPriceField value={purchasePrice} onChange={handlePurchasePriceChange} label="Purchase Price"/>
                            </div>
                        <div className="flex-auto">
                            <InputPriceField value={sellingPrice} onChange={handleSellingPriceChange} label="Selling price"/>
                        </div>

                            
                            <div className="flex-auto">
                                <label htmlFor="calendar-12h" className="font-bold block mb-2">
                                    Choose Currency                     
                                </label>
                                <InputSelectionDropdown 
                                        value={currency}
                                        onChange={handleCurrencyChange}
                                        options={currencyOptions}
                                        optionLabel="label" 
                                        placeholder="Choose Currency"
                                />                            
                                </div>
                                <div className="flex-auto">
                                    <label htmlFor="calendar-12h" className="font-bold block mb-2">
                                        Is taxable                                
                                    </label>
                                    <InputSelectionDropdown 
                                        value={isTaxable !== null ? isTaxable.toString() : ""}
                                        onChange={handleIsTaxableChange} 
                                        options={[
                                            { value: "true", label: "Yes" },
                                            { value: "false", label: "No" },
                                        ]} 
                                        optionLabel="label" 
                                        placeholder="Is taxable" 
                                        />                         
                                </div>
                                {isTaxable && (
                                        <div className="flex-auto">
                                            <label htmlFor="calendar-12h" className="font-bold block mb-2">
                                                Is taxable                                
                                            </label>
                                            <InputFieldText value={taxRate} onChange={handleTaxRateChange} label="Enter Tax Rate"/>
                                        </div>
                                        )}    
                    </div>


                   
                    <div className="flex-auto">
                    
                        
                
                <FormSeperator content="Seller details" />
                <InputFeildTextArea value={sellerDescription} onChange={handleSellerDescriptionChange} label="Enter seller details"/>
                <FormSeperator content="Warranty Details" />
                <InputFeildTextArea value={warrantyDetails} onChange={handleWarrantyDetailsChange} label="Enter warranty details"/>

                </div>
                </div>
                <div className="flex align-items-center gap-2 mt-4">
                            <Button
                                label="Save"
                                onClick={(event) => {
                                    addProduct();
                                }}
                                className="w-8rem"
                            ></Button>
                            {onCancel && 
                                <Button
                                    label="Cancel"
                                    outlined
                                    onClick={(event) => onCancel(event)}
                                    className="w-8rem"
                                ></Button>}
                        </div>
      
    </div>
  )
}

export default AddProductForm
